import useStore from "./useStore";

export default function useSelectors(...selectors) {
  const [state] = useStore();
  return selectors.map(selector => selector(state));
}
